/**
 * Capitalize strings
 *
 * @param s Value to capitalize
 *
 * @returns Converted value with first capitalized letter
 */
export function capitalize(s: string): string {
    if (!s) {
        return s;
    }
    const arr: string[] = s.split(' ');

    for (let i = 0; i < arr.length; i++) {
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }

    return arr.join(' ');
}
